import { z } from "zod";
import { ForgeIterationMessage } from "./iteration-message";
import { ForgeArtifact } from "./artifact";

export const ForgeProjectIterationMergeMeta = z.object({ mergeByUserId: z.string(), mergeAt: z.date() });

export const ForgeProjectIteration = z.object({
  branchId: z.string().optional(),
  buildArtifactId: z.string(),
  createdAt: z.coerce.date(),
  forgeProjectId: z.string(),
  id: z.string(),
  locked: z.boolean(),
  messages: z.array(ForgeIterationMessage),
  artifacts: z.array(ForgeArtifact),
  previousIterationId: z.string().optional(),
  mergeMeta: ForgeProjectIterationMergeMeta.optional(),
});

export type ForgeProjectIteration = z.infer<typeof ForgeProjectIteration>;
